import useFeature from './useFeature';

const useIsSessionReplayEnabled = () => {
  const { isFeatureEnabled, isLoading } = useFeature('session_replay_enabled');

  return { isEnabled: isFeatureEnabled, isLoading };
};

export default useIsSessionReplayEnabled;
